module.exports = __webpack_public_path__ + "static/media/bannerImage.0b722546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bannerImage.png
// module id = 1649
// module chunks = 0